import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <div className="navbar bg-base-100">
      <div className="flex-1">
        <Link to="/" className="btn btn-ghost normal-case text-xl">
          Warface Competitive
        </Link>
      </div>
      <div className="flex-none">
        <ul className="menu menu-horizontal px-1">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/match-history">Match History</Link>
          </li>
          <li>
            <a href="https://www.faceitstatus.com/" target="_blank" rel="noopener noreferrer">Status</a>
          </li>
          <li>
            <a href="https://www.faceit.com/en/club/4f0e8392-6da2-47d3-8b46-3422b85114c8/" target="_blank" rel="noopener noreferrer">Play</a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Navbar;